import type { IconDefinition } from '../index.tsx';

export const iconApple: IconDefinition = {
  prefix: 'fas',
  iconName: 'iconApple',
  icon: [
    16,
    16,
    [],
    '',
    'M12.4996 8.46367C12.4996 8.53509 12.3925 10.6421 14.7137 11.7491C14.2852 13.0705 12.7853 15.9988 11.0354 15.9988C10.0355 15.9988 9.46411 15.356 8.32133 15.356C7.14285 15.356 6.50004 15.9988 5.60724 15.9988C3.89308 16.0703 2.25035 12.8562 1.7861 11.5349C1.42898 10.5349 1.28613 9.57073 1.28613 8.64222C1.28613 5.46389 3.39312 3.92828 5.39297 3.89257C6.35719 3.89257 7.57139 4.57109 8.10706 4.57109C8.60703 4.57109 9.99978 3.74973 11.2854 3.85686C12.6067 3.964 13.6067 4.46396 14.2852 5.42817C13.1067 6.17812 12.4996 7.14233 12.4996 8.46367ZM10.4997 2.60695C9.78551 3.42832 8.92843 3.89257 7.99993 3.82115C7.9285 2.85693 8.28562 1.96414 8.92843 1.24991C9.49982 0.607098 10.4997 0.0714233 11.3568 0C11.3568 0.392828 11.464 1.46418 10.4997 2.60695Z',
  ],
};
